import { render, staticRenderFns } from "./SearchSamples.vue?vue&type=template&id=6751f1c9"
import script from "./SearchSamples.vue?vue&type=script&lang=js"
export * from "./SearchSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports